import * as d3 from 'd3'
import * as dc from 'dc'
import { BUY_COLOR, SELL_COLOR } from '@/utils/flowSightColors'
import { formatCompactAmount } from '@/utils/utils'

// "Volume by Side" (Volume por Ponta) bar chart (Overview tab). Splits the
// BRL-converted notional between the BUY and SELL sides.
//
// Uses store.convertNotionalToBRL like the currency/KPI charts (NOT the
// hard-coded FX table that createStatusBarChart still carries), so its total
// reconciles with the "Volume Total" KPI.
//
// Colors are per-key (BUY/SELL) instead of the single global sideColor - this
// chart IS the side breakdown, so Overview.vue's _applyGlobalSideFromStore()
// deliberately skips recoloring it.
const SIDES = ['BUY', 'SELL']

export function createSideVolumeChart ({ el, ndx, chartGroup, width, store, t }) {
  const dim = ndx.dimension((d) => (d.side || '').toUpperCase())
  const rawGroup = dim.group().reduceSum((d) => store.convertNotionalToBRL(d) || 0)

  // Keeps both bars on screen (at 0) even when a filter empties one side,
  // and drops any unexpected raw side value without touching the crossfilter
  // group itself.
  const group = {
    all: () => {
      const map = new Map(rawGroup.all().map((kv) => [kv.key, kv.value]))
      return SIDES.map((key) => ({ key, value: map.get(key) || 0 }))
    },
  }

  const label = (key) => (key === 'BUY' ? t('flowSight.buy') : t('flowSight.sell'))

  const chart = new dc.BarChart(el, chartGroup)
  chart
    .width(width)
    .height(200)
    .x(d3.scaleBand().domain(SIDES))
    .xUnits(dc.units.ordinal)
    .margins({ left: 50, right: 30, top: 25, bottom: 50 })
    .brushOn(false)
    .gap(5)
    .controlsUseVisibility(true)
    .dimension(dim)
    .elasticY(true)
    .renderHorizontalGridLines(true)
    .renderVerticalGridLines(true)
    .group(group)
    .clipPadding(40)
    .renderLabel(true)
    .label((d) => {
      const total = d3.sum(group.all(), (kv) => kv.value)
      const percent = total > 0 ? (d.data.value / total) * 100 : 0
      return `${percent.toFixed(0)}%`
    })
    .title((d) => `${label(d.key)}: R$ ${d3.format(',.0f')(d.value)}`)
    .colors(d3.scaleOrdinal().domain(SIDES).range([BUY_COLOR, SELL_COLOR]))
    .colorAccessor((d) => d.key)

  chart.xAxis().tickFormat(label)
  chart.yAxis().tickFormat((v)=>formatCompactAmount(v)).ticks(6)
  chart.render()
  return chart
}
